var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatWithCareTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 1.5835H3.16668C2.29584 1.5835 1.58334 2.296 1.58334 3.16683V17.4168L4.75001 14.2502H15.8333C16.7042 14.2502 17.4167 13.5377 17.4167 12.6668V3.16683C17.4167 2.296 16.7042 1.5835 15.8333 1.5835ZM15.8333 12.6668H4.75001L3.16668 14.2502V3.16683H15.8333V12.6668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWithCareTeam);
export default __webpack_public_path__ + "static/media/ChatWithCareTeam.d210e18d2856c345b07a8c06c6fc68e6.svg";
export { ForwardRef as ReactComponent };